/**
 * Health System Details Routes
 * legacy app: canActivate: [AuthGuard] (standalone top-level in head-routing)
 * Also appears as a child of overview-page-advocate (AdvocateModule)
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const Hsd = lazy(() =>
  import('@src/apps/Hsd/Hsd').then(m => ({ default: m.Hsd }))
);

export const healthSystemDetailsRoutes: RouteConfig[] = [
  {
    path: 'health-system-details',
    component: Hsd,
    guards: ['auth'],
    data: {
      title: 'Health System Details',
      breadcrumb: 'Health System Details',
    },
  },
];

